/**
 * Reads an error body from the API or a Cloud Function.
 *
 * Both answer with RFC 9457 problem details: `code` is the stable identifier to
 * branch on, `detail` is the sentence to show, and `request_id` finds the
 * request in the server logs. A body written before that format carries only
 * `error`, which is a code when it is snake_case and a sentence otherwise.
 */
export interface ProblemInfo {
  code: string | null;
  message: string;
  requestId: string | null;
}

const SNAKE_CASE = /^[a-z][a-z0-9_]*$/;

export function readProblem(body: unknown, fallback: string): ProblemInfo {
  const b = (body && typeof body === "object" ? body : {}) as Record<string, unknown>;
  const text = (v: unknown) => (typeof v === "string" && v.trim() ? v : null);
  const legacy = text(b.error);
  return {
    code: text(b.code) ?? (legacy && SNAKE_CASE.test(legacy) ? legacy : null),
    message: text(b.detail) ?? legacy ?? fallback,
    requestId: text(b.request_id),
  };
}
